import 'swiper/css';

import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {A11y} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';

import useBadgeDetailRoute from '@/hooks/useBadgeDetailRoute';
import {selectAllBadges} from '@/state/selectors/loyalty';

import BadgeDetailSlide from './BadgeDetailSlide';
import useBadgeDetailStack, {SLIDE_MS} from './useBadgeDetailStack';

type BadgeDetailSceneProps = {
    titleId?: string;
};

const BadgeDetailScene = ({titleId}: BadgeDetailSceneProps) => {
    const {stack, onSwiper} = useBadgeDetailStack();
    const {badgeId: activeBadgeId, closePopup} = useBadgeDetailRoute();
    const allBadges = useSelector(selectAllBadges);

    // Close the popup if the active badge/journey was removed from the store.
    // For multi-level journeys the URL stores journeyId (stable), so the check
    // covers both id and journeyId to handle badge-id only URLs too.
    useEffect(() => {
        if (activeBadgeId && !allBadges.some((b) => b.id === activeBadgeId || b.journeyId === activeBadgeId)) {
            closePopup();
        }
    }, [activeBadgeId, allBadges, closePopup]);

    if (!stack.length) return null;

    return (
        <Swiper
            className='h-full w-full'
            modules={[A11y]}
            slidesPerView={1}
            spaceBetween={0}
            speed={SLIDE_MS}
            allowTouchMove={false}
            onSwiper={onSwiper}
        >
            {stack.map((entry, index) => (
                <SwiperSlide key={entry.key} className='h-full overflow-auto'>
                    {({isActive}) => (
                        <div aria-hidden={!isActive || undefined} inert={!isActive || undefined}>
                            <BadgeDetailSlide
                                badgeId={entry.badgeId}
                                levelBadgeId={entry.levelBadgeId}
                                titleId={index === 0 ? titleId : undefined}
                            />
                        </div>
                    )}
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

export default BadgeDetailScene;
